<template>
  <div class="mob-inject">
    <template v-if="homeShow">
       <!-- 場景選擇 -->
        <scene-select
                :no-bg="false"
                @changeScene="loadScene"
                :sel-scene="selectScene"
        ></scene-select>
        <div class="add-box" v-if="guideObj.points && Object.keys(guideObj.points).length === 0">
      <div class="add-inject" @click="addGuide" >{{$t('publish.tagAdd')+$t('edit.guide.guideTitle')}}</div>
      </div>
      <div class="follow-old" v-else>
        <div class="base-container">
          <div class="list-container">
            <div class="oild-list">
              <GuideItem
                v-for="(value, index) in guideObj.points"
                :key="index"
                :index="index+1"
                :isFirst="index === 0"
                :listData="value"
                :selected="selectedItem"
                @selectedItem="onClickItem"
              ></GuideItem>
            </div>
          </div>
          <div class="adds" @click="addGuide" v-show="showAddBtn">
                <div>
                    <img src="../../assets/img/mob_add_scene.png"/>
                    <h5>{{$t('edit.guide.addGuide')}}</h5>
                </div>
          </div>
          <!-- <div class="add-new" @click="addGuide">
            <div class="text">{{$t('publish.tagAdd')}}</div>
            <div class="text">{{$t('edit.guide.guideTitle')}}</div>
          </div> -->
        </div>
        <!-- <div class="options" v-if="selectedItem.title">
          <div class="options-btn" @click="renameItem">{{$t('actionTitles.rename')}}</div>
          <div class="options-btn" @click="editItem">{{$t('actionTitles.edit')}}</div>
          <div class="options-btn" @click="deleteItem">{{$t('actionTitles.delete')}}</div>
        </div> -->
         <!-- 編輯導航 -->
    <edit-options
            v-if="editGuideVisible"
            :options="options"
            @returnBack="closeOptions"
            @onclick="editOptions"
    ></edit-options>
      </div>
    </template>
    <template v-if="showAddPannel">
      <AddPannel
        :targetObj="selectedItem"
        @onClickBack="changeToShowHome"
        @saveChangeData="saveChangeData"
      ></AddPannel>
    </template>
    <!--重命名-->
    <a-modal v-model="renameVisible" :title="$t('actionTitles.rename')" :destroyOnClose="true" @ok="handleConfirm">
      <div>
        <div>
          <a-input v-model="newName" :addonBefore="$t('edit.guide.guideName.label')" :placeholder="selectedItem.title"></a-input>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import GuideItem from "./component/GuideItem";
import AddPannel from "./component/AddPannel.vue";
import { v4 as uuidv4 } from "uuid";
import SceneSelect from "../scenes/SceneSelect";
import EditOptions from "../EditOptions";

export default {
  components: { GuideItem, AddPannel ,SceneSelect,EditOptions},
  data() {
    return {
      hotspotObj: {},
      homeShow: true,
      isAddNew: true,
      currentTypeItem: {},

      guideObj: {},
      showAddPannel: false,
      selectedItem: {},
      renameVisible: false,
      newName: "",
      selectScene:[],
      editGuideVisible: false,
      options:[
        {title: this.$t('actionTitles.rename'), src: require('../../assets/img/mob_rename.png'), type: 'rename'},
        {title: this.$t('actionTitles.edit'), src: require('../../assets/img/mob_create.png'), type: 'edit'},
        {title: this.$t('actionTitles.delete'), src: require('../../assets/img/mob_delete.png'), type: 'delete'},
      ],
      showAddBtn:true
    };
  },
   watch: {
    currentScenesId:{
       handler(newVal){
      this.$set(this.selectScene, 0, newVal);
       }
    },
  },
  created() {
    this.guideObj = this.editGuide;
    this.selectScene[0] = this.currentScenesId;
  },
  computed: { ...mapGetters(["vrbase", "currentScenesId", "editGuide"]) },
  methods: {
    addGuide() {
      this.editGuideVisible = false;
      const currIndex = this.guideObj.points.length;
      let viewAt = getSceneViewAt();
      const sampleObj = {
        point_id: "point_" + uuidv4().replace(/-/g, ""),
        scene_id: this.currentScenesId,
        index: currIndex + 1,
        title: this.$t('edit.guide.guideName.defaultName'),
        ath: viewAt.hlookat,
        atv: viewAt.vlookat,
        fov: viewAt.fov,
        move_time: "5",
        music_url: "",
        music_title: "",
        content: "",
      };

      this.$set(this.guideObj.points, currIndex, sampleObj);

      // this.$store.dispatch("setVRBase", this.vrbase);
      this.updateStoreGuide();
      this.setGuidePoint(sampleObj);
      this.selectedItem = sampleObj;
      this.showAddPannel = true;
      this.homeShow = false;
      this.showAddBtn = true;
    },
    updateStoreGuide() {
      this.$set(this.vrbase.guide, 0, this.guideObj);
      this.$store.dispatch("setVRBase", this.vrbase);
    },
    setGuidePoint(point) {
      removeGuidePoint(point.point_id);
      addGuidePoint({
        point_id: point.point_id,
        ath: point.ath,
        atv: point.atv,
        index: point.index,
      });
    },
    onClickItem(value) {
      this.showAddBtn = false;
      this.editGuideVisible = true;
      this.selectedItem = value;
      lookto(value.ath, value.atv, value.fov);// click to move to point
    },

    onClickType(item) {
      this.currentTypeItem = item;
    },
    onClickNext() {
      if (this.currentTypeItem.type) {
        this.changeToShowHome(this.currentTypeItem.type);
      } else {
        this.$message.error(this.$t('edit.editMessage.hotPSelect'));
      }
    },
    changeToShowHome() {
      this.showAddPannel = false;
      this.homeShow = true;
    },
    // saveDataToStore({ key, data }) {
    //   this.changeToShowHome();
    //   let vrbase = this.vrbase;
    //   this.$set(this.hotspotObj, key, data); // 更新本地
    //   vrbase.scenes[this.currentScenesId].hotspot[key] = data;
    //   this.$store.dispatch("setVRBase", vrbase);
    //   // this.showAddPannel = false; //增加數據後顯示增加的 數據
    // },
    renameItem() {
      this.renameVisible = true;
    },
    editItem() {
      this.showAddPannel = true;
      this.homeShow = false;
      this.showAddBtn = true;
    },
    deleteItem() {
      const item = this.selectedItem
      const _this = this;
      this.$confirm({
        title: _this.$t('edit.editMessage.title'),
        content: _this.$t('edit.editMessage.content'),
        okText: _this.$t('edit.editMessage.okText'),
        okType: "danger",
        cancelText: _this.$t('edit.editMessage.cancelText'),
        onOk() {
          _this.handleDelete(item);
        },
        onCancel() {
          console.log("取消");
        },
      });
    },
    handleDelete(item) {
      removeGuidePoint(item.point_id);
      const index = this.getTargetObjIndex(item);
      if (index > -1) {
        this.$delete(this.guideObj.points, index);
        this.updateStoreGuide();
        this.reSetIndex();
      }
    },
    // 重新設置每個的index
    reSetIndex() {
      for (let i = 0; i < this.guideObj.points.length; i++) {
        const item = this.guideObj.points[i];
        item.index = i + 1;
        this.setGuidePoint(item);
      }
    },
    // handleHotspotChange(val, oldVal) {
    //   console.log("==0==", val, oldVal);
    //   setHotspot(val, oldVal);
    // },
    saveChangeData(changeData) {
      const index = this.getTargetObjIndex(changeData);
      if (index > -1) {
        this.$set(this.guideObj.points, index, changeData);
        // this.vrbase.guide[0] = this.guideObj;
        // this.$store.dispatch("setVRBase", this.vrbase);
        this.updateStoreGuide();

        this.showAddPannel = false;
        this.homeShow = true;
      }
    },
    // 獲取數組中對象的位置
    getTargetObjIndex(obj) {
      let index = -1;
      for (let i = 0; i < this.guideObj.points.length; i++) {
        const item = this.guideObj.points[i];
        if (obj.point_id === item.point_id) {
          index = i;
        }
      }
      return index;
    },
    handleConfirm() {
      if (this.newName === "") return;
      // this.guideObj.points[
      this.$set(this.selectedItem, "title", this.newName);
      // this.vrbase.guide[0] = this.guideObj;
      // this.$store.dispatch("setVRBase", this.vrbase);
      this.updateStoreGuide();
      this.renameVisible = false;
      // reset data
      this.newName = "";
      this.selectedItem = {};
    },
    loadScene(id){
      this.$store.dispatch("loadScene", id);
      this.closeOptions();
    },
    //關閉編輯
     closeOptions(){
      this.editGuideVisible = false;
      this.showAddBtn = true;
      this.curPointId = ''
    },
    //option的功能
    editOptions(type){
      if(type == 'rename'){
        this.renameItem()
      }
      if(type == 'edit'){
        this.editItem()
      }
      if(type == 'delete'){
        this.deleteItem()
      }
      this.editGuideVisible = false
    },
  },
};
</script>

<style lang="less" scoped>
.mob-inject{
    padding: 0 !important;
}
// .base-container .list-container{
//   background-color: none !important;
// }
</style>